import React from "react";

const CashWallets = (props) => {
  // const [buttonText, setButtonText] = useState("View My Wallets");

  // // Handle Copy Button Click
  // const handleCopyClick = () => {
  //   const codeText = document.querySelector(".code mark").textContent;
  //   const textarea = document.createElement("textarea");
  //   document.body.appendChild(textarea);
  //   textarea.value = codeText;
  //   textarea.select();

  //   try {
  //     document.execCommand("copy");
  //     setButtonText("Copied!");

  //     // Reset text after 2 seconds
  //     setTimeout(() => {
  //       setButtonText("Copy");
  //     }, 2000);
  //   } catch (err) {
  //     console.error("Copy failed", err);
  //   }

  //   document.body.removeChild(textarea);
  // };

  return (
    <section
      id="id_memecoin_service_section"
      className={`memecoin_service_section bg-white  section_space z-2 pt-0 pb-5 position-relative ${props.tokenClass}`}
    >
      <div class="container">
        <div class="row justify-content-center">
          <div className="col-lg-7">
            <div className="px-4 py-4">
              <div className="mt-4">
                <h1 className=" text-theme text-center ">
                  Important Tax Information
                </h1>
                <h4 className=" text-theme text-center ">
                  Applies to Reward Withdrawals
                </h4>
                <p className="text-dark text-center opacity-50">
                  TopCoin UK — Transparency, Trust, and Loyalty Rewards
                </p>
              </div>
            </div>
            <div className="card shadow-sm border border-opacity-50 bg-white mb-3">
              <div className="card-body">
                <h5 className="text-dark-emphasis">
                  At TopCoin UK, rewards within the platform may appear in three
                  forms:
                </h5>
                <ul className="mb-0 text-dark-emphasis">
                  <li>
                    TopCoin Wallets – These track your loyalty participation and
                    TopCoin progress within the TopCoin UK platform.
                  </li>
                  <li>
                    Reward Cash Wallets – These display promotional reward
                    balances that may become available according to TopCoin UK
                    programme rules.
                  </li>
                  <li>
                    Reward Bonus Wallets (Bounce Wallets) – These may contain
                    additional promotional rewards linked to participation
                    within the platform.
                  </li>
                </ul>
                <div className="bg bg-light-subtle mt-3 text-theme p-3 border rounded-3">
                  {/* <p className="mb-0 small">Please Note:</p> */}
                  <p className="mb-0">
                    TopCoin itself is a loyalty reward unit within the TopCoin
                    UK platform and does not represent money, an investment, or
                    a financial product.
                  </p>
                </div>
                {/* <div className="text-center py-2 mb-0">
                  <p className="text-dark-emphasis">
                    This tax guidance applies only to cash withdrawals, not to
                    TopCoin balances.
                  </p>
                </div> */}
              </div>
            </div>
            <div className="card bg-white  shadow-sm border border-opacity-5 mb-3">
              <div className="card-body min-h250">
                <h5 className="text-dark-emphasis py-2">
                  Reward Withdrawals and Tax
                </h5>
                <ul className="mb-0 text-dark-emphasis ">
                  <li>
                    Where customers choose to withdraw money from their TopCoin
                    Wallet, Reward Cash Wallet, or Reward Bonus Wallet, the
                    withdrawn amount may be subject to tax depending on the laws
                    that apply to the customer.
                  </li>
                  <li>
                    Rewards held within the TopCoin UK platform are loyalty
                    rewards linked to retail participation and may not be
                    taxable while they remain within the platform.
                  </li>
                  <li>Taxes may apply when rewards are withdrawn as cash.</li>
                </ul>
              </div>
            </div>

            <div className="card bg-white  shadow-sm border border-opacity-5 mb-3">
              <div className="card-body min-h250">
                <h5 className="text-dark-emphasis py-2">Reward Withdrawals</h5>
                <ul className="mb-0 text-dark-emphasis ">
                  <li>
                    Eligible reward withdrawals are processed according to the
                    TopCoin UK programme rules.
                  </li>
                  <li>
                    Withdrawals are processed through the TopCoin UK platform
                    from the United Kingdom.
                  </li>
                  <li>
                    Tax treatment may depend on the customer’s country of
                    residence and local tax regulations.
                  </li>
                  <li>
                    TopCoin rewards are not investments, not interest, and not
                    financial returns.
                  </li>
                  <li>
                    Reward eligibility is based on participation within the
                    TopCoin loyalty platform and retail activity.
                  </li>
                </ul>
              </div>
            </div>

            <div className="card bg-white  shadow-sm border border-opacity-5 mb-3">
              <div className="card-body min-h250">
                <h5 className="text-dark-emphasis py-2">
                  Customer Tax Responsibility
                </h5>
                <ul className="mb-0 text-dark-emphasis ">
                  <li>TopCoin UK Ltd does not provide tax advice.</li>
                  <li>
                    Customers are responsible for understanding and complying
                    with their own tax obligations under the laws of their
                    country of residence.
                  </li>
                  <li>
                    Customers should consult HM Revenue and Customs or a
                    qualified tax professional if they are unsure about their
                    tax obligations.
                  </li>
                </ul>
              </div>
            </div>

            <div className="card bg-white  shadow-sm border border-opacity-5 mb-3">
              <div className="card-body min-h250">
                <h5 className="text-dark-emphasis py-2">
                  Important Legal Notice
                </h5>
                <ul className="mb-0 text-dark-emphasis ">
                  <li>
                    Participation in the TopCoin UK platform does not create
                    employment, financial investment, or guaranteed financial
                    returns.
                  </li>
                  <li>
                    Any TopCoin rewards, bonus rewards, or cash rewards
                    available within the platform are provided solely as part of
                    a loyalty and promotional programme linked to retail
                    participation.
                  </li>
                  <li>
                    Nothing on the TopCoin UK platform should be interpreted as
                    financial advice, investment advice, or a promise of
                    financial return.
                  </li>
                  <li>
                    TopCoin UK Ltd accepts no responsibility for individual tax
                    reporting obligations or financial interpretations made by
                    participants.
                  </li>
                </ul>
              </div>
            </div>

            <div className="card bg-white  shadow-sm border border-opacity-5 mb-3">
              <div className="card-body min-h200">
                <h5 className="text-dark-emphasis py-2">TopCoin UK</h5>
                <p className="text-dark-emphasis">
                  Transparency • Trust • Loyalty Rewards
                </p>
              </div>
            </div>
          </div>
        </div>

        {/*  <div class="row justify-content-center ">
          <div className="col-lg-6">
            <p className="text-center text-dark opacity-50">
              Topcoin UK Transparency, Trust, and Rewards You Can Rely On.
            </p>
          </div>
        </div> */}
      </div>
    </section>
  );
};

export default CashWallets;
